import {initWebComponent} from "@/helpers/web-component-helper";
import {zoomToLayer} from "@/helpers/ol/ol-zoom-helper";
import {setViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";


export class LayerMenuActiveItemZoomScaleComponent extends HTMLElement{
    constructor(){
        super();

        const minScale = this.getAttribute('data-min-scale')
        const maxScale = this.getAttribute('data-max-scale')

        const template = document.createElement('template');
        template.innerHTML = `<div>De kaart is buiten bereik. Klik op <a href="#" class="text-dark"><span class="fa fa-eye-slash"></span></a> om de kaart zichtbaar te maken</div>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            setViewResolution(minScale, maxScale)
        });
    }
}
